/**
 * DestinationPopup - Popup for fishing destinations on the map.
 */
import { X, Heart, Navigation } from 'lucide-react';

export default function DestinationPopup({
  destination,
  onClose,
  onToggleFavorite,
  onViewDetails,
  onDirections,
}) {
  return (
    <div className="relative min-w-[280px] max-w-[320px]">
      <button
        onClick={onClose}
        className="absolute top-2 right-2 p-1.5 rounded-full bg-black/50 hover:bg-black/70 text-white transition-colors z-10"
        data-testid="popup-close-btn"
      >
        <X className="w-4 h-4" />
      </button>

      <button
        onClick={() => onToggleFavorite?.(destination.id)}
        className="absolute top-2 left-2 p-1.5 rounded-full transition-colors z-10 bg-black/50 text-white hover:bg-black/70"
        data-testid="dest-favorite-btn"
      >
        <Heart className="w-4 h-4" />
      </button>

      {destination.image_url && (
        <div className="w-full h-32 overflow-hidden rounded-t-lg">
          <img
            src={destination.image_url}
            alt={destination.name}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="p-3">
        <h3 className="font-serif text-lg font-semibold leading-tight mb-1">
          {destination.name}
        </h3>
        <p className="text-sm text-gray-600 mb-2">{destination.state}</p>

        {destination.target_species?.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-3">
            {destination.target_species.slice(0, 3).map(species => (
              <span key={species} className="px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-700">
                {species}
              </span>
            ))}
          </div>
        )}

        <div className="flex gap-2">
          <button
            onClick={() => onViewDetails?.(destination)}
            className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-accent text-white rounded-md text-sm font-medium hover:bg-accent/90 transition-colors"
            data-testid="popup-view-details-btn"
          >
            View Details
          </button>
          <button
            onClick={() => onDirections(destination)}
            className="flex items-center justify-center gap-1 px-3 py-2 border border-gray-300 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors"
            data-testid="popup-directions-btn"
            title="Get Directions"
          >
            <Navigation className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
